/* ============
 * All Postals
 * ============
 *
 * All postals from a country.
 */

import Vue from 'vue';
import store from './../../store';
import postalTransformer from './../../transformers/postal';

const success = ({ data }, resolve) => {
  const postals = postalTransformer.fetchCollection(data.data);

  store.dispatch('fetchPostals', { postals });
  resolve();
};

const failed = () => {
};

// Display postals related to a country.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('postal')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/postal/all.js